"use client"

import * as React from "react"
import { Toaster as Primitive } from "sonner"

import { clx } from "@/lib/utils"

type ToasterProps = Omit<
  React.ComponentPropsWithoutRef<typeof Primitive>,
  "richColors" | "closeButton" | "icons" | "theme" | "invert" | "loadingIcon" | "cn"
>

/**
 * Mounted once in the root layout. Call sites use `toast` from "sonner".
 */
const Toaster = ({
  position = "bottom-right",
  gap = 12,
  offset = 24,
  duration,
  ...props
}: ToasterProps) => {
  const primitiveProps = {
    ...props,
    position,
    gap,
    offset,
    cn: clx,
    toastOptions: {
      duration,
    },
  }
  return <Primitive {...primitiveProps} />
}

export { Toaster }
